import {getQueryParameters} from '../utils/global';

export class Filter {
    /**
     * 絞り込み
     *
     * @constructor
     * @param {HTMLElement} root - ルートとなる要素
     * @param {Object} options - 設定の変更をする際のオブジェクト
     */
    constructor(root, options) {
        const config = {
            selectAllValue: 'all',
            className: {
                ctrl: 'js-filter__ctrl',
                content: 'js-filter__content',
                category: 'p-layout-product__categoryTag',
                noticeText: 'c-text-notice',
                number: 'js-filter__number'
            },
            text: {
                notice: '該当する商品が存在しません'
            },
            categoryNumber: null
        };

        // ルートとなる要素がない場合何もしない
        if (!root) {
            return;
        }

        this.config = Object.assign(config, options);
        this.root = root;
        this.ctrls = Array.from(root.querySelectorAll(`.${this.config.className.ctrl}`));
        this.content = root.querySelector(`.${this.config.className.content}`);
        this.number = root.querySelector(`.${this.config.className.number}`);
        [this.hasSelectAllValueElement] = this.ctrls.filter((ctrl) => ctrl.value === this.config.selectAllValue);
        this.filterNumber = this.content.querySelector('#js-filter-number');
        if (this.filterNumber) {
            this.config.categoryNumber = this.filterNumber.dataset;
            this.filterNumber.outerHTML = '';
            this.filterNumber = '';
        }
        this.filterTargets = this.content.children;
        this.categories = this.getCategory();
        this.notixeText = document.createElement('p');
        this.dividedByCategoryElements = this.dividedByCategory();
        this.currentCategories = [];
        this.currentElements = [];
        this.isAllTargetHidden = false;

        if (!this.filterTargets.length) {
            return;
        }

        this.init();
        this.addEvent();
    }

    /**
     * getCategoryName - クラス名からmodifierを取得
     * @param  {Array} categoryList 絞り込みが実行されるカテゴリ一覧
     * @param  {Array} classArray   クラス名のリスト
     * @return {String}
     */
    static getCategoryName(categoryList, classArray) {
        let categoryName = 'other';

        // 空のリストが渡された場合'other'を返す
        if (!categoryList.length || !classArray.length) {
            return categoryName;
        }

        for (const className of classArray) {
            // 'c-text-solidTag--'で始まるクラス名でない場合はスルー
            if (!/^c-text-solidTag--/.test(className)) {
                continue;
            }

            [categoryName] = className.split('--').slice(-1);
            break;
        }

        return categoryList.includes(categoryName) ? categoryName : 'other';
    }

    /**
     * init - 初期化
     * @return {Void}
     */
    init() {
        // [data-sync-parameter]が指定されている場合、URLパラメータを参照し、初期値を変更する
        if (this.root.dataset.syncParameter) {
            const paramArray = getQueryParameters();
            const {syncParameter} = this.root.dataset;

            // URLパラメータにで指定したキー名が存在する場合
            if (paramArray.hasOwnProperty(syncParameter)) {
                for (const ctrl of this.ctrls) {
                    if (paramArray[syncParameter].split(',').includes(ctrl.value)) {
                        ctrl.checked = true;
                        this.setCategoryNumber(ctrl.value);
                    }
                }

            // URLパラメータにで指定したキー名が存在しない場合、デフォルトの要素を選択済みにする
            } else {
                this.hasSelectAllValueElement.checked = true;
                this.setCategoryNumber(this.hasSelectAllValueElement.value);
            }
        }

        this.notixeText.classList.add(this.config.className.noticeText);
        this.notixeText.textContent = this.config.text.notice;

        // 初期実行
        this.check(this.hasSelectAllValueElement.checked);
        this.filter();
    }

    /**
     * getCategory - 各要素のカテゴリー情報を取得
     * @return {Array}
     */
    getCategory() {
        const ctrlsCategories = this.ctrls.map((element) => element.value);
        const categories = [];

        for (const target of this.filterTargets) {
            const categoryTag = target.querySelector(`.${this.config.className.category}`);

            categories.push(Filter.getCategoryName(ctrlsCategories, categoryTag !== null ? categoryTag.classList : []));
        }

        return categories;
    }

    /**
     * フィルターするカテゴリに応じて件数を表示する
     * 件数を表示する要素、もしくは件数の情報がなければ処理が走らない
     * @param  {String} category どのカテゴリか このカテゴリに応じて件数を出し分ける
     */
    setCategoryNumber(category) {
        if (!this.number || !this.config.categoryNumber) {
            return;
        }
        this.number.textContent = this.config.categoryNumber[category];
    }

    /**
     * getCurrentElements - 選択されているカテゴリを持つ要素のリストを取得
     * @return {NodeList}
     */
    getCurrentElements() {
        let currentElements = [];

        for (const category of this.currentCategories) {
            if (!this.dividedByCategoryElements.hasOwnProperty(category)) {
                continue;
            }

            currentElements = currentElements.concat(this.dividedByCategoryElements[category]);
        }

        return currentElements;
    }

    /**
     * dividedByCategory - 要素をカテゴリごとの配列に分け、取得
     * @return {Object}
     */
    dividedByCategory() {
        const elementData = {};

        elementData[this.config.selectAllValue] = Array.from(this.filterTargets);

        for (let i = 0; i < this.categories.length; i++) {
            const category = this.categories[i];

            // オブジェクトがカテゴリーのキーを持っている場合、配列に追加
            if (elementData.hasOwnProperty(category)) {
                elementData[category].push(this.filterTargets[i]);

                continue;
            }

            // 持っていない場合、配列として要素を代入
            elementData[category] = [this.filterTargets[i]];
        }

        return elementData;
    }

    /**
     * addEvent - イベントバインド
     */
    addEvent() {
        for (const ctrl of this.ctrls) {
            ctrl.addEventListener('change', (e) => {
                this.check(e.target === this.hasSelectAllValueElement);
                this.filter();
                this.setCategoryNumber(e.target.value);
            });
        }
        window.addEventListener('pageshow', () => {
            if (!this.root.dataset.syncParameter) {
                this.hasSelectAllValueElement.checked = true;
            }
        });
    }

    /**
     * filter - 絞り込みを実行
     * @return {Void}
     */
    filter() {
        let isAllTargetHidden = true;

        // カレントのカテゴリ・要素を更新
        this.currentCategories = this.ctrls.filter((element) => element.checked).map((element) => element.value);
        this.currentElements = this.getCurrentElements();

        for (const target of this.filterTargets) {
            const isHidden = [].indexOf.call(this.currentElements, target) === -1;

            // 表示される要素（isHidden === false）が1つでもある場合
            if (isAllTargetHidden && !isHidden) {
                isAllTargetHidden = false;
            }

            target.hidden = isHidden;
        }

        // 全て非表示 ⇒ 表示 or 表示 ⇒ 全て非表示 に切り替わった時
        if (this.isAllTargetHidden !== isAllTargetHidden) {
            this.content.hidden = isAllTargetHidden;

            // 表示 ⇒ すべて非表示なった場合、テキストを追加
            if (isAllTargetHidden) {
                this.content.parentNode.insertBefore(this.notixeText, this.content.nextSibling);

            // すべて非表示 ⇒ 表示になった場合、テキストを削除
            } else {
                this.content.parentNode.removeChild(this.notixeText);
            }
        }

        // フラグを更新
        this.isAllTargetHidden = isAllTargetHidden;
    }

    /**
     * check - チェックボックスの表示制御
     * @param  {Boolean} isChangeCheckedAll 「すべて」をクリックしたかどうか
     * @return {Void}
     */
    check(isChangeCheckedAll) {
        const currentCategories = this.ctrls.filter((element) => element.checked).map((element) => element.value);
        const checkedValueLength = currentCategories.length;

        // チェックされている要素が1つもない場合 または 「すべて」以外の選択肢全てにチェックがついている場合、「すべて」にチェック
        if (isChangeCheckedAll || checkedValueLength === 0 || checkedValueLength === (this.ctrls.length - 1)) {
            for (const ctrl of this.ctrls) {
                ctrl.checked = ctrl.value === this.config.selectAllValue;
            }

            this.hasSelectAllValueElement.disabled = !isChangeCheckedAll;

            return;
        }

        this.hasSelectAllValueElement.checked = false;
        this.hasSelectAllValueElement.disabled = false;
    }
}

/**
 * デフォルト実行処理
 * @return {Void}
 */
export default () => {
    // 絞り込み機能
    document.querySelectorAll('.js-filter').forEach((element) => new Filter(element));
};
